import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DepartmentsComponent } from './journey/departments/departments.component';
import { ServicesComponent } from './journey/services/services.component';
import { LocationComponent } from './journey/location/location.component';
import { CalendarComponent } from './journey/calendar/calendar.component';
import { BookingDetailsComponent } from './journey/booking-details/booking-details.component';
import { SummaryComponent } from './journey/summary/summary.component';
import { ConfirmationComponent } from './journey/confirmation/confirmation.component';
import { RegisterComponent } from './journey/register/register.component';
import { MainAccountComponent } from './account-journey/main-account/main-account.component';
import { AccountGuardService } from './services/guards/account-guard.service';
import { AccessComponent } from './journey/access/access.component';
import { AccessibilityStatementComponent } from './journey/accessibility-statement/accessibility-statement.component';
import { AmendPermitsSubmittedComponent } from './journey/amend-permits-submitted/amend-permits-submitted.component';
import { AmendPermitsComponent } from './journey/amend-permits/amend-permits.component';
import { PermitsSubmittedComponent } from './journey/permits-submitted/permits-submitted.component';
import { PermitsComponent } from './journey/permits/permits.component';
import { CookiePolicyComponent } from '@bookinglab/hwrc-ui';

export const routes: Routes = [
  { path: '', redirectTo: '/access', pathMatch: 'full' },
  {
    path: 'departments',
    loadComponent: () =>
      import('./journey/departments/departments.component').then(
        (m) => m.DepartmentsComponent
      ),
  },
  {
    path: 'services',
    loadComponent: () =>
      import('./journey/services/services.component').then(
        (m) => m.ServicesComponent
      ),
    data: { breadcrumb: 'Services' },
  },
  {
    path: 'locations',
    loadComponent: () =>
      import('./journey/location/location.component').then(
        (m) => m.LocationComponent
      ),
  },
  {
    path: 'calendar',
    loadComponent: () =>
      import('./journey/calendar/calendar.component').then(
        (m) => m.CalendarComponent
      ),
    data: { breadcrumb: 'Date & Time' },
  },
  {
    path: 'booking-details',
    loadComponent: () =>
      import('./journey/booking-details/booking-details.component').then(
        (m) => m.BookingDetailsComponent
      ),
    data: { breadcrumb: 'Booking Form' },
  },
  {
    path: 'summary',
    loadComponent: () =>
      import('./journey/summary/summary.component').then(
        (m) => m.SummaryComponent
      ),
    data: { breadcrumb: 'Summary' },
  },
  {
    path: 'confirmation',
    loadComponent: () =>
      import('./journey/confirmation/confirmation.component').then(
        (m) => m.ConfirmationComponent
      ),
    data: { breadcrumb: 'Confirmation' },
  },
  {
    path: 'access',
    loadComponent: () =>
      import('./journey/access/access.component').then(
        (m) => m.AccessComponent
      ),
    data: { breadcrumb: 'Access' },
  },
  {
    path: 'register',
    loadComponent: () =>
      import('./journey/register/register.component').then(
        (m) => m.RegisterComponent
      ),
  },
  {
    path: 'account',
    loadComponent: () =>
      import('./account-journey/main-account/main-account.component').then(
        (m) => m.MainAccountComponent
      ),
    canActivate: [AccountGuardService],
  },
  {
    path: 'accessibility-statement',
    loadComponent: () =>
      import(
        './journey/accessibility-statement/accessibility-statement.component'
      ).then((m) => m.AccessibilityStatementComponent),
  },
  {
    path: 'permits',
    loadComponent: () =>
      import('./journey/permits/permits.component').then(
        (m) => m.PermitsComponent
      ),
  },
  {
    path: 'permits-submitted',
    loadComponent: () =>
      import('./journey/permits-submitted/permits-submitted.component').then(
        (m) => m.PermitsSubmittedComponent
      ),
  },
  {
    path: 'amend-permits',
    loadComponent: () =>
      import('./journey/amend-permits/amend-permits.component').then(
        (m) => m.AmendPermitsComponent
      ),
  },
  {
    path: 'amend-permits-submitted',
    loadComponent: () =>
      import(
        './journey/amend-permits-submitted/amend-permits-submitted.component'
      ).then((m) => m.AmendPermitsSubmittedComponent),
  },
  {
    path: 'cookies',
    loadComponent: () =>
      import('@bookinglab/hwrc-ui').then((m) => m.CookiePolicyComponent),
  },

  // { path: 'account-login', component: AccountLoginComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
